document.addEventListener("DOMContentLoaded", function() {
    // 延遲 500 毫秒，確保 BEST Currency Converter 已初始化完成
    setTimeout(function() {
      // 取得 BEST Currency Converter 的貨幣選擇器容器
      var currencySwitcher = document.querySelector(".doubly-nice-select.currency-switcher");
      if (!currencySwitcher) {
        console.warn("找不到貨幣選擇器元素");
        return;
      }
  
      // 如果 currencySwitcher 位於 .language-currency-wrapper 中，則改用父層（不包含該 wrapper）的元素
      var wrapper = currencySwitcher.closest(".language-currency-wrapper");
      if (wrapper && wrapper.parentElement) {
        var temp = wrapper.parentElement.querySelector(".doubly-nice-select.currency-switcher");
        if (temp) {
          currencySwitcher = temp;
        }
      }
  
      // 取得目前顯示幣別的 span 元素（內含旗標與文字）
      var currentSpan = currencySwitcher.querySelector("span.current");
      if (!currentSpan) {
        console.warn("找不到顯示目前幣別的元素");
        return;
      }
  
      // 讀取目前顯示的幣別文字，移除所有空白並轉成大寫
      var currentText = currentSpan.textContent.replace(/\s+/g, '').toUpperCase();
      console.log("目前顯示幣別文字：", currentText);
  
      // 根據目前顯示的文字判斷目標選項：
      // 如果包含 USD，目標為 USD；如果包含 TWD，目標為 TWD；如果包含 JPY，目標為 JPY
      var targetValue = null;
      if (currentText.indexOf("USD") !== -1) {
        targetValue = "USD";
      } else if (currentText.indexOf("TWD") !== -1) {
        targetValue = "TWD";
      } else if (currentText.indexOf("JPY") !== -1) {
        targetValue = "JPY";
      }
  
      if (targetValue) {
        // 從選項清單中找出 data-value 等於 targetValue 的 li 元素
        var targetOption = currencySwitcher.querySelector("li.option[data-value='" + targetValue + "']");
        if (targetOption) {
          console.log("偵測到目前幣別為 " + currentText + "，準備延遲模擬點擊 " + targetValue + " 選項...");
          // 延遲 1000 毫秒後模擬點擊選項
          setTimeout(function() {
            targetOption.click();
            console.log("已模擬點擊 " + targetValue + " 選項");
            // 再延遲 500 毫秒後模擬點擊貨幣選擇器本身，讓下拉選單收回
            setTimeout(function() {
              currencySwitcher.click();
              console.log("已模擬點擊貨幣選擇器以收回下拉選單");
            }, 500);
          }, 1000);
        } else {
          console.warn("找不到目標選項：" + targetValue);
        }
      } else {
        console.log("目前幣別不屬於 USD、TWD 或 JPY，未觸發模擬點擊");
      }
    }, 500);
  });